<template>
  <div class="mr-3">
    <button
      type="button"
      :class="[
        'btn btnclass smallerfontsize',
        apiBodyMeasures.length > 0 ? 'selected' : ''
      ]"
      @click="fieldData.showTargetGroupModal = true"
    >
      Target / Metric
    </button>
    <b-modal
      v-model="fieldData.showTargetGroupModal"
      dialog-class="targetgroupmodal"
      scrollable
      title="Select target group / metric"
      @hidden="cancelTargetGroups"
      @ok="saveTargetGroups"
      @show="showModal"
    >
      <b-form-row>
        <b-col sm="6">
          <label for="group-selection">Target group</label>
          <b-form-select
            id="group-selection"
            v-model="form.group.selected"
            :options="form.group.options"
            size="sm"
          />
        </b-col>

        <b-col
          sm="6"
          class="mb-2"
        >
          <label for="measurements-selection">Metric</label>
          <b-form-select
            id="measurements-selection"
            v-model="fieldData.measurements.selected"
            :options="fieldData.measurements.options"
            size="sm"
          />
        </b-col>

        <b-col sm="4">
          <label for="age-from-selection">Age from</label>
          <b-form-select
            id="age-from-selection"
            v-model="form.age.from.selected"
            size="sm"
          >
            <option
              v-for="ageFrom in form.age.from.options"
              :key="ageFrom.value"
              :disabled="ageFrom.value < form.age.to.selected ? false : true"
              :value="ageFrom.value"
            >
              {{ ageFrom.text }}
            </option>
          </b-form-select>
        </b-col>

        <b-col sm="4">
          <label for="age-to-selection">Age to</label>
          <b-form-select
            id="age-to-selection"
            v-model="form.age.to.selected"
            size="sm"
          >
            <option
              v-for="ageTo in form.age.to.options"
              :key="ageTo.value"
              :disabled="ageTo.value > form.age.from.selected ? false : true"
              :value="ageTo.value"
            >
              {{ ageTo.text }}
            </option>
          </b-form-select>
        </b-col>
        <b-col sm="4">
          <label for="age-to-selection">Reach criteria</label>
          <b-form-select
            id="reach-target-group"
            v-model="selectedReachCriteria"
            :disabled="isReachCriteriaDisabled"
            :options="reachCriteriaOptions"
            size="sm"
          />
        </b-col>
      </b-form-row>
      <b-form-row class="mt-3 mb-2">
        <b-col cols="12">
          <b-button
            class="mr-2"
            variant="success"
            size="sm"
            @click="add"
          >
            Add
          </b-button>
          <b-button
            v-if="measures.length > 1"
            class="mr-2"
            variant="danger"
            size="sm"
            @click="deleteAllSelections"
          >
            Remove all
          </b-button>
        </b-col>
      </b-form-row>
      <div class="pt-2">
        <small
          class="font-weight-bold"
        >Please note that for reach, a maximum of 28 days is displayed.</small>
      </div>
      <b-list-group class="mt-3">
        <b-list-group-item
          v-for="(measure, index) in measures"
          :key="index"
        >
          <span>
            {{ measure.measure_name }}
          </span>
          <b-button
            class="mr-2 float-right"
            variant="danger"
            size="sm"
            @click="deleteSelection(index)"
          >
            Remove
          </b-button>
        </b-list-group-item>
      </b-list-group>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          @click="ok()"
        >
          Save
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { fetchFormFieldData } from '../../../assets/js/api.js';
import globalConfig from "../../../mixins/globalConfig"

export default {
  name: 'TargetGroupCampaignModal',
  mixins: [globalConfig],
  props: {
    fieldData: Object,
    chosenPeriod: String,
  },
  data() {
    return {
     
      selectedReachCriteria: 5,
      reachCriteriaOptions: [
        { value: 1, text: '1 sec', selectedReachCriteriaText: '1 sec' },
        { value: 2, text: '2 sec', selectedReachCriteriaText: '2 sec' },
        { value: 5, text: '5 sec or 50% of length', selectedReachCriteriaText: '5 sec/50%' },
        { value: 10, text: '10 sec', selectedReachCriteriaText: '10 sec' },
        { value: 15, text: '15 sec', selectedReachCriteriaText: '15 sec' },
        { value: 20, text: '20 sec', selectedReachCriteriaText: '20 sec' },
        { value: 30, text: '30 sec', selectedReachCriteriaText: '30 sec' },
        { value: 60, text: '60 sec', selectedReachCriteriaText: '60 sec' },
        { value: 120, text: '120 sec', selectedReachCriteriaText: '120 sec' },
        { value: 180, text: '180 sec', selectedReachCriteriaText: '180 sec' },
      ],
      measures: [],
      hasChange: false,
      form: {
        group: {
          selected: 'All',
          options: [
            { value: 'All', text: 'All' },
            { value: 'Women', text: 'Women' },
            { value: 'Men', text: 'Men' },
          ],
        },
        age: {
          from: {
            selected: 3,
            options: [],
          },
          to: {
            selected: 99,
            options: [],
          },
        },
      },
    };
  },
  computed: {
    isReachCriteriaDisabled() {
      let visibleReachSelectors = [
        ...this.fieldData.measurements.options.filter(measure => measure.showReachSelector),
      ].map(m => m.value);
      return !visibleReachSelectors.includes(this.fieldData.measurements.selected);
    },
    isReachSelected() {
      let isReachSelected = !this.isReachCriteriaDisabled;
      return isReachSelected;
    },
    apiBodyMeasures() {
      return this.$store.getters['campaignApiBody/getPayload'].measures;
    }
  },
  beforeDestroy() {
    // Clean up by removing the event listener when the component is destroyed
    document.removeEventListener("keyup", this.onKeyUp);
  },
  async created() {
    this.setupTargetGrups();
    this.$store.commit('campaignApiBody/updateMeasures', this.measures);
  },
  methods: {
    onKeyUp(event) {
      if (event.key === "Enter" && this.fieldData.showTargetGroupModal) {
        this.fieldData.showTargetGroupModal = false;
        this.saveTargetGroups()      
      }
    },
    showModal() {
      document.addEventListener("keyup", this.onKeyUp);
      this.setTargetGroupsFromLocalStorage();
    },
    setTargetGroupsFromLocalStorage() {
      let storedTargets = this.$store.state.campaignApiBody.payload.measures;
      this.measures = [...storedTargets];
    },
    async setupTargetGrups() {
      let targetGroups = await fetchFormFieldData('TargetGroups');

      if (targetGroups.statusCode) {
        this.$bvToast.toast(targetGroups.errorMessage, {
          title: 'Warning',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000,
        });
      }

      this.form.age.from.options = [];
      let uniqueTargetGoups = targetGroups.filter(function(obj) {
        return obj.gender === 'Man';
      });

      for (let index in uniqueTargetGoups) {
        this.form.age.from.options.push({
          value: uniqueTargetGoups[index].age_from,
          text: uniqueTargetGoups[index].age_from,
        });
        this.form.age.to.options.push({
          value: uniqueTargetGoups[index].age_to,
          text: uniqueTargetGoups[index].age_to,
        });
      }
    },
    add() {
      document.activeElement.blur()
      let maxTargetGroupCount;
      if (Number.isInteger(this.config_NumberOfTargetGroupsAd)) maxTargetGroupCount = this.config_NumberOfTargetGroupsAd
      else maxTargetGroupCount = 8
      if (this.measures.length >= maxTargetGroupCount) {
        this.$bvToast.toast('Maximum number of target groups is ' + maxTargetGroupCount, {
          title: 'Warning',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000,
        });
      } else {
        this.addTargetGroup();
      }
    },
    addTargetGroup() {
      let min_viewing_time = 0;
      let gender = this.form.group.selected.charAt(0);
      let measurement = this.fieldData.measurements.selected;
      this.fieldData.measurements.options.forEach(element => {
        if (element.value == this.fieldData.measurements.selected) {
          measurement = element.text;
        }
      });
      let ageFrom = this.form.age.from.selected;
      let ageTo = this.form.age.to.selected;
      let targetGroupString = `${measurement} ${gender}${ageFrom}-${ageTo}`;
      if (this.isReachSelected) {
        min_viewing_time = this.selectedReachCriteria;
        let selectedReachCriteriaText = this.reachCriteriaOptions.filter(function(reachCriteria) {
          if (reachCriteria.value === this) return reachCriteria;
        }, this.selectedReachCriteria)[0].selectedReachCriteriaText;
        targetGroupString = `${targetGroupString}, ${selectedReachCriteriaText}`;
      }
      const targetGroupAlreadyExist = this.measures.some(
        tg => tg.measure_name === targetGroupString,
      );
      if (targetGroupAlreadyExist) {
        this.$bvToast.toast('Targetgroup already exist', {
          title: 'Warning',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000,
        });
      } else {
        this.updateMeasuresForSearch(targetGroupString, min_viewing_time);
      }
    },
    updateMeasuresForSearch(measureName, min_viewing_time) {
      let measure = {
        measure_type: this.fieldData.measurements.selected,
        consolidation_days: -1,
        target_group_keys: this.getTargetGroupKeys(),
        min_viewing_time,
        measure_name: measureName,
        reachAbsHeader: "Reach indv",
        reachRelHeader: "Reach %",
        ageGroup: `${this.form.group.selected.charAt(0)}${this.form.age.from.selected}-${this.form.age.to.selected}`
      };
      this.measures.push(measure);
    },
    getTargetGroupKeys() {
      let target_group_keys = [];
      this.form.age.to.options.forEach(age => {
        if (age.value <= this.form.age.to.selected && age.value > this.form.age.from.selected) {
          if (this.form.group.selected === 'Women' || this.form.group.selected === 'All') {
            target_group_keys.push('female_age' + age.value);
          }
          if (this.form.group.selected === 'Men' || this.form.group.selected === 'All') {
            target_group_keys.push('male_age' + age.value);
          }
        }
      });
      return target_group_keys;
    },
    deleteSelection(index) {
      this.measures.splice(index, 1);
    },
    deleteAllSelections() {
      this.measures = [];
    },
    cancelTargetGroups() {
      document.removeEventListener("keyup", this.onKeyUp);
      this.measures = [...this.$store.state.campaignApiBody.payload.measures];
    },
    saveTargetGroups() {
      const measuresForApiBody = this.measures.map(m => ({ ...m }));
      const measuresForReachApiBody = this.measures.map(m => ({ ...m }));
      this.$store.commit('campaignApiBody/updateMeasures', measuresForApiBody);
      this.$store.commit('campaignReachApiBody/updateMeasures', measuresForReachApiBody);
      if (this.measures.length === 0)
        this.$emit('onGoToListTab');

    },
  },
};
</script>
<style scoped>
.showline {
  text-decoration: line-through;
}
</style>